import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import FlexBox from 'flexbox-react';
import PhaseDetailsBar from 'phaseDetailsBar';
import contentAreaStyles from 'styles/contentArea';
import PhaseForm from 'phaseForm';
import { updatePhase, loadPhase, navigate, clearValidationErrors } from 'actionCreators';
import { getPhaseErrors } from '../../../../../reducers';
import connectUI from 'redux-ui';
import { urls } from 'helpers/url';
import Loading from 'components/Loading';
import PhaseType from 'types/phase';

class PhaseEdit extends Component {
  componentDidMount = () => {
    if (this.props.phase.id !== this.props.id) this.props.loadPhase(this.props.id);
  };

  componentWillUnmount = () => this.props.clearValidationErrors('PHASE');

  handleCancel = () => this.props.navigate(urls.phaseInfo(this.props.phase));

  handleSave = phase => this.props.updatePhase(phase, {})
    .then(() => this.props.navigate(urls.phaseInfo(this.props.phase)))
    .catch(() => {});

  render = () => {
    const { errors, loaded, phase, role, position } = this.props;
    return (loaded ? <div>
      <Helmet title={phase.customer_name} />
      <PhaseDetailsBar
        phase={phase}
        role={role}
        position={position}
      />
      <FlexBox>
        <div className={contentAreaStyles.contentAreaContainer}>
          <PhaseForm
            phase={phase}
            errors={errors}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
            role={role}
            loading={phase.loading}
          />
        </div>
      </FlexBox>
    </div> : <Loading />);
  }
}

PhaseEdit.propTypes = {
  phase: PhaseType,
  id: PropTypes.number,
  errors: PropTypes.object,
  loaded: PropTypes.bool,
  role: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
  updatePhase: PropTypes.func.isRequired,
  loadPhase: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { phase: { details: phase = {} }, user: { role = '', position = '' } = {} } = state;
  return {
    id: Number(ownProps.params.id),
    phase,
    loaded: phase.loaded || false,
    errors: getPhaseErrors(state) || {},
    role,
    position,
  };
};

export default connectUI()(connect(mapStateToProps, {
  navigate, updatePhase, loadPhase, clearValidationErrors,
})(PhaseEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseEdit/index.jsx